export default {
  SET_PCP_DETAILS_BEGIN: 'SET_PCP_DETAILS_BEGIN',
  SET_PCP_DETAILS_SUCCESS:'SET_PCP_DETAILS_SUCCESS',
  SET_PCP_ERROR: 'SET_PCP_ERROR',
  SET_PCP_CLEANUP: 'SET_PCP_CLEANUP',
  SET_VALUE : 'SET_VALUE',
  SET_CLEANUP: 'SET_CLEANUP',
};